import React from "react";
import icon1 from "../../assets/image/icon1.png";
import numicon1 from "../../assets/image/numicon1.png";
import cardarrowbtn from "../../assets/image/cardarrowbtn.png";
import { baseUrl } from "../../utils/base_url";
import { Button } from "../Button/Button";
import { useMediaQuery } from "react-responsive";

import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _2200px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";

export const ShadowCard = ({
  isCrdWhite = false,
  topIcon,
  topHeading,
  text,
  lineColor,
  textClass,
  headingClass,
  topIConHeight,
  topIConWidth,
  imgurl,
}) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const _2200 = useMediaQuery({ maxWidth: _2200px });
  return (
    <>
      <div
        className={`position-relative  ${
          isCrdWhite ? "text-black pb-5 pt-4" : "text-white pt-4  "
        } `}
        style={{
          width: isCrdWhite?"90%": "100%",
          height: "100%",
          // width: "464px", height: "490px",
          // width: "400px", height: "505px",
          backgroundImage: isCrdWhite
            ? "linear-gradient(to bottom , #F6F6F6, #BFBFBF)"
            : "linear-gradient(to bottom , #1D1D1D, #2B2A2A)",
          borderRadius: "1rem",
          boxShadow: "0 0 20px #0039EC",
          overflow: "hidden",
        }}
      >
        <div
          className="position-absolute bottom-0 end-0 "
          style={{
            background: " #1F46BE",
            width: isCrdWhite ? "24%" : "40%",
            height: isCrdWhite ? "31%" : "35%",
            clipPath: "polygon(0 100%, 100% 0, 100% 100%)",
            zIndex: 0,
          }}
        />
        <div
          className="px-4 d-flex flex-column justify-content-between position-relative "
          style={{ width: "100%", height: "100%", zIndex: 2 }}
        >
          <div className="d-flex flex-column justify-content-between">
            <div className="pb-lg-3">
              <div // className="d-flex gap-3 justify-content-start pb-3"
                className={
                  isCrdWhite
                    ? "d-md-flex flex-column align-items-start gap-3 mb-3"
                    : "d-lg-flex align-items-center gap-3 pb-2 pb-lg-4"
                }
              >
                <img
                  src={`${baseUrl}${topIcon}`}
                  style={{
                    width: _576
                      ? "55px"
                      : _768
                      ? "50px"
                      : _992
                      ? "70px"
                      : _1200
                      ? "60px"
                      : _1400
                      ? "50px"
                      : _1500
                      ? "45px"
                      : _1600
                      ? "70px"
                      : _1700
                      ? "70px"
                      : _1800
                      ? "80px"
                      : "90px",
                    height: _576
                      ? "55px"
                      : _768
                      ? "50px"
                      : _992
                      ? "70px"
                      : _1200
                      ? "60px"
                      : _1400
                      ? "50px"
                      : _1500
                      ? "45px"
                      : _1600
                      ? "70px"
                      : _1700
                      ? "70px"
                      : _1800
                      ? "80px"
                      : "90px",
                  }}
                  className="pb-2 pb-lg-0"
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: topHeading?.replace(/\n/g, "<br/>"),
                  }}
                  className={headingClass}
                  style={{
                    lineHeight: 1.1,
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    margin: "0",
                  }}
                >
                  {/* {topHeading} */}
                </p>
              </div>
              <hr
                style={{
                  height: "2px",
                  backgroundColor: lineColor,
                  opacity: 1,
                  border: "none",
                  margin: "0 0 1rem 0",
                }}
              />
            </div>

            <p className={`${textClass} lh-sm`} >
              {text}
            </p>
          </div>
          {isCrdWhite ? (
            ""
          ) : (
            <div className={`d-flex justify-content-between align-items-center`} style={{paddingBottom:_576?"20px":"30px"}}>
              <Button
                className={"rounded-circle p-2"}
                width={_1800?"70px":"83.51px"}
                height={_1800?"75px":"89.5px"}
                background="transparent"
                border={"2px solid white"}
                children={
                  <img
                    src={cardarrowbtn}
                    style={{ width: "37.78px", height: "31.38px" }}
                  />
                }
              />
              <img
                src={`${baseUrl}${imgurl}`}
                className="me-3"
                style={{
                  width: _1800
                    ? "68px"
                    : "78.22px",
                  height: 
                     _1800
                    ? "76px"
                    : "97.37px",
                }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default ShadowCard;
